import { logError } from 'client/javascript/util/logger';
import { trackInteraction } from 'client/javascript/analytics';

const CARD_ARTICLE_TYPE = 'Ideas';
export const ANALYTICS = {
  interactions: [
    {
      className: 'analytics-card-article-ideas-image',
      label: `Click - ${CARD_ARTICLE_TYPE} Card - Image`
    },
    {
      className: 'analytics-card-article-ideas-subcategory',
      label: `Click - ${CARD_ARTICLE_TYPE} Card - Subcategory`
    },
    {
      className: 'analytics-card-article-ideas-headline',
      label: `Click - ${CARD_ARTICLE_TYPE} Card - Heading`
    },
    {
      className: 'analytics-card-article-ideas-description',
      label: `Click - ${CARD_ARTICLE_TYPE} Card - Description`
    }
  ]
};

export function setupCardArticleIdeasAnalytics(card, index) {
  try {
    card.addEventListener('click', (event) => {
      const currentElement = event.target;
      // position of the card based on the card order within contentful
      const position = index + 1;

      if (currentElement) {
        const { label } = ANALYTICS.interactions.find(({ className }) =>
          Array.from(currentElement.classList).includes(className)
        );

        trackInteraction({ label, position });
      }
    });
  } catch (error) {
    logError(`[Shared modules] setupCardArticleIdeasAnalytics failed: ${error.message}`, error);
  }
}
